import { recievePersons } from "./reducer";
import { APIClient } from "../../../helpers/api_helper";
const api = new APIClient();

export const loadPersons = () => async (dispatch, getState) => {

    try {
        const data = await api.get('/api/persons/get_options/')

        if (data) {
            dispatch(recievePersons(data));
        }
    } catch (error) {
        console.error('Unable to load persons!', error)
    }
};
